import { defineComponent as _defineComponent } from 'vue'
import Dialog from '../../common/base/Dialog';
import SvgIcon from '../../common/base/SvgIcon.vue';
import ArrowStrokeSelectDownIcon from '../../common/icons/ArrowStrokeSelectDownIcon.vue';
import useUserInfo from './useUserInfoHooks';
import Avatar from '../../common/Avatar.vue';
import TuiButton from '../../common/base/Button.vue';
import TuiInput from '../../common/base/Input.vue';
import { isInnerScene } from '../../../utils/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoPC',
  props: {
    userId: null,
    userName: null,
    avatarUrl: null,
    isShowEditName: { type: Boolean, default: false }
  },
  emits: ['log-out'],
  setup(__props: any) {

const props = __props as { userId: string, userName: string, avatarUrl?: string, isShowEditName: boolean }

const {
  t,
  showUserControl,
  showUserNameEdit,
  userInfoRef,
  tempUserName,
  handleUserControl,
  showEditUserNameDialog,
  closeEditUserNameDialog,
  handleSaveUserName } = useUserInfo();



const showEditNameContainer = isInnerScene && props.isShowEditName;

return { __sfc: true,t, showUserControl, showUserNameEdit, userInfoRef, tempUserName, handleUserControl, showEditUserNameDialog, closeEditUserNameDialog, handleSaveUserName, props, showEditNameContainer, Dialog, SvgIcon, ArrowStrokeSelectDownIcon, Avatar, TuiButton, TuiInput }
}

})